import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { Power3 } from "gsap";
import { smootherPause } from "../smoother";

gsap.registerPlugin(ScrollTrigger);

export const showContent = e => {
    let tl = gsap.timeline();
    tl.to('.theme-container', {
        y: 0,
        delay: 0.4,
        duration: .4,
        ease: Power3.in
    }).from('.theme-footer', {
        y: '100vh',
        duration: .4,
        ease: Power3.in,
        onComplete: () => {
            ScrollTrigger.refresh();
            smootherPause(false);
        }
    }, '<')
}
